module.exports = __webpack_public_path__ + "img/bule.755555e5.png";